import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { offlineLink } from "./lib/offline-link";
import { trpc } from "./lib/trpc";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 15_000, refetchInterval: 15_000, refetchOnWindowFocus: true } },
});
// La coda sta prima della rete e vale per tutte le scritture, anche quelle non ancora
// scritte: nessuna schermata deve ricordarsi di aggiungerla.
const trpcClient = trpc.createClient({
  links: [offlineLink(), httpBatchLink({ url: "/api/trpc", maxItems: 3, maxURLLength: 1500 })],
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </trpc.Provider>
  </StrictMode>,
);
